module.exports = __webpack_public_path__ + "img/thumb_image6.6562ba63.jpg";